import Vue from 'vue'
import selectInput from './common/selectInput'
import splitPane from 'vue-splitpane'
import rangePicker from './common/rangePicker'
import insertRow from './common/insertRow'
import xTable from './common/xTable'
import xTableColumn from './common/xTableColumn'
import SelectPopover from './common/SelectPopover'
Vue.component('select-input', selectInput);
Vue.component('split-pane', splitPane);
Vue.component('range-picker', rangePicker);
Vue.component('insert-row', insertRow);
Vue.component('x-table', xTable);
Vue.component('x-table-column', xTableColumn);
Vue.component('select-popover', SelectPopover);